import React from 'react';
import styled from 'styled-components';

import {
  FormControl as MuiFormControl,
  Typography as MuiTypography,
} from '@mui/material';

const FormControl = styled((props) => {
  const { children, label, labelStyle, color, ...controlProps } = props;

  return (
    <MuiFormControl {...controlProps}>
      {label && (
        <MuiTypography variant="h5" style={labelStyle} color={color} gutterBottom>
          {label}
        </MuiTypography>
      )}
      {children}
    </MuiFormControl>
  );
})`
  && {
    width: 100%;
    margin-bottom: 15px;

    fieldset {
      border-color: ${({theme}) => theme.palette.colors.gray200};
    }
  }
`;

export default FormControl;
